import { Routes, Route } from "react-router-dom";
import { OrganizationAccessGate } from "@/components/organization/OrganizationAccessGate";
import { PlatformAdminRoute, OrgAdminRoute, AuthenticatedRoute } from "@/components/auth/RouteGuards";
import Index from "@/pages/Index";
import NewProfile from "@/pages/NewProfile";
import ProfileSetup from "@/pages/ProfileSetup";
import Bookings from "@/pages/Bookings";
import BookingDetails from "@/pages/BookingDetails";
import AdminPanel from "@/pages/AdminPanel";
import OrganizationAdmin from "@/pages/OrganizationAdmin";
import OrganizationDetailAdmin from "@/pages/OrganizationDetailAdmin";
import DevOrganizationTester from "@/pages/DevOrganizationTester";
import NotFound from "@/pages/NotFound";
import Loading from "@/pages/Loading";
import Header from "@/components/layout/Header";
import { useState } from "react";

/**
 * Protected routes using unified context from App.tsx
 * No duplicate providers - uses shared AuthProvider and OrganizationProvider
 */
export const ProtectedRoutes = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="min-h-screen relative">
          {isLoading ? (
            <Loading onComplete={() => setIsLoading(false)} />
          ) : (
            <>
              <Routes>
                {/* Protected routes with organization access control */}
                <Route path="/app" element={
                  <OrganizationAccessGate>
                    <AuthenticatedRoute>
                      <Header />
                      <main className="pt-2 pb-20 md:pt-4 md:pb-4 relative z-10">
                        <Index />
                      </main>
                    </AuthenticatedRoute>
                  </OrganizationAccessGate>
                } />
                
                <Route path="/profile" element={
                  <OrganizationAccessGate>
                    <AuthenticatedRoute>
                      <Header />
                      <main className="pt-2 pb-20 md:pt-4 md:pb-4 relative z-10">
                        <NewProfile />
                      </main>
                    </AuthenticatedRoute>
                  </OrganizationAccessGate>
                } />
                
                <Route path="/profile-setup" element={
                  <OrganizationAccessGate>
                    <AuthenticatedRoute>
                      <Header />
                      <main className="pt-2 pb-20 md:pt-4 md:pb-4 relative z-10">
                        <ProfileSetup />
                      </main>
                    </AuthenticatedRoute>
                  </OrganizationAccessGate>
                } />
                
                <Route path="/bookings" element={
                  <OrganizationAccessGate>
                    <AuthenticatedRoute>
                      <Header />
                      <main className="pt-2 pb-20 md:pt-4 md:pb-4 relative z-10">
                        <Bookings />
                      </main>
                    </AuthenticatedRoute>
                  </OrganizationAccessGate>
                } />
                
                <Route path="/bookings/:bookingId" element={
                  <OrganizationAccessGate>
                    <AuthenticatedRoute>
                      <Header />
                      <main className="pt-2 pb-20 md:pt-4 md:pb-4 relative z-10">
                        <BookingDetails />
                      </main>
                    </AuthenticatedRoute>
                  </OrganizationAccessGate>
                } />
                
                {/* Platform Admin routes - bypass organization access control */}
                <Route path="/admin" element={
                  <PlatformAdminRoute>
                    <Header />
                    <main className="pt-2 pb-20 md:pt-4 md:pb-4 relative z-10">
                      <AdminPanel />
                    </main>
                  </PlatformAdminRoute>
                } />
                
                <Route path="/admin/organizations/:orgId" element={
                  <PlatformAdminRoute>
                    <Header />
                    <main className="pt-2 pb-20 md:pt-4 md:pb-4 relative z-10">
                      <OrganizationDetailAdmin />
                    </main>
                  </PlatformAdminRoute>
                } />
                
                <Route path="/dev-org-tester" element={
                  <PlatformAdminRoute>
                    <Header />
                    <main className="pt-2 pb-20 md:pt-4 md:pb-4 relative z-10">
                      <DevOrganizationTester />
                    </main>
                  </PlatformAdminRoute>
                } />
                
                {/* Organization Admin routes - super admins bypass organization checks */}
                <Route path="/org-admin" element={
                  <OrgAdminRoute>
                    <Header />
                    <main className="pt-2 pb-20 md:pt-4 md:pb-4 relative z-10">
                      <OrganizationAdmin />
                    </main>
                  </OrgAdminRoute>
                } />
                
                {/* Catch all */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </>
          )}
        </div>
  );
};